<i18n src="./resources/locales.json"></i18n>

<template>
  <div class="pointer" @contextmenu.prevent="onShowContextMenu($event)" @click="onSidebarInteractionClick()">
    <v-list-item
      class="interaction-item"
      :class="{
        blink: shouldBlink
      }"
    >
      <v-list-item-avatar>
        <EcsInteractionAvatar :interaction="interaction" :size="40" />
      </v-list-item-avatar>

      <v-list-item-content>
        <v-list-item-title class="interaction-title">
          {{ tileTitle }}
        </v-list-item-title>
        <v-list-item-subtitle class="interaction-sub-title">
          <span>{{ fromNow(interaction.timestamp, 'UTC') }}</span>
        </v-list-item-subtitle>
      </v-list-item-content>

      <v-list-item-action class="flip-container">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon :style="{ color: interactionStatus.color }" v-on="on">
              {{ interactionStatus.icon }}
            </v-icon>
          </template>
          <span>{{ $t(interactionStatus.statusName) }}</span>
        </v-tooltip>
      </v-list-item-action>
    </v-list-item>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import EcsInteractionMixin from '@/mixins/ecs-interaction-mixin/EcsInteractionMixin';
import EcsSideBarInteractionItemMixin from '@/mixins/ecs-side-bar-interaction-mixins/EcsSideBarInteractionItemMixin';
import EcsInteractionAvatar from '@/components/ecs-base-interaction-components/ecs-avatar/EcsInteractionAvatar';

export default {
  name: 'EcsSideBarEmailInteractionItem',

  components: { EcsInteractionAvatar },

  mixins: [EcsInteractionMixin, EcsSideBarInteractionItemMixin],

  props: {
    interaction: {
      type: Object,
      required: true
    }
  },

  computed: {
    ...mapGetters('CONTACTS', ['getContactV2']),

    interactionStatus() {
      let result;

      if (this.interaction.isHandled) {
        if (this.interaction.timing.answeredWithinGoalTime) {
          result = this.iconMap.answeredWithinGoalTime;
        } else {
          result = this.iconMap.completed;
        }
      } else if (this.interaction.isCanceled) {
        result = this.iconMap.emailRead;
      } else if (this.interaction.isOutgoingEmail) {
        result = this.iconMap.newEmail;
      } else {
        result = this.iconMap[this.interaction.interactionStateId] || this.iconMap.emailRead;
      }

      return result;
    },

    contact() {
      return this.getContactV2(this.interaction.receptor.id || this.interaction.crm.contactId);
    },

    tileTitle() {
      const altName = (this.contact ? this.contact.name : null) || this.$t('newEmail');
      return this.interaction.isOutgoingEmail && !(this.interaction.receptor || {}).name
        ? altName
        : (this.interaction.receptor || {}).name;
    }
  }
};
</script>

<style src="./scoped.css" scoped />
